import React from "react";
import Form from "./Form";
import { useFormik } from "formik";
import { createWithEntry } from "ducks/properties";
import { add } from "ducks/toasts";

import { connect } from "react-redux";
import { useRemoveQueryNavigation } from "helpers/hooks/url";

const CreateProperty = ({ add, createWithEntry, entry_id }) => {
  const onClose = useRemoveQueryNavigation("createProperty");

  const { values, handleSubmit, setFieldValue } = useFormik({
    initialValues: {
      data: {},
      entry_id
    },
    onSubmit: values => {
      createWithEntry(values);
      add(
        "Update erfolgreich",
        "Benutzer wurde erfolgreich erstellt",
        "success",
        "user"
      );
    }
  });

  return (
    <Form
      subtitle="Neuen Datensatz erstellen"
      values={values}
      handleChange={setFieldValue}
      handleSubmit={handleSubmit}
      handleClose={onClose}
    ></Form>
  );
};

export default connect(null, { createWithEntry, add })(CreateProperty);
